export default "__VITE_ASSET__CLZBFTYl__"